export default __webpack_public_path__ + "static/media/202.359bf2dc.jpg";